import React from 'react';
import { useSelector } from 'react-redux';
import { stationDatasourceIdsSelector } from 'Features/App/Dictionaries/dictionariesSlice';
import { useGeneralStationsStyles } from 'Features/StationsNew/useStyles';
import { stationDatasourceIdsFromFilteredSelector } from 'Features/Filters/Stations';
import { Pane, PaneProps } from 'evergreen-ui';
import DatasourceNavigationRow from './DatasourceNavigationRow';

type DatasourcesTableProps = PaneProps & {
  stationId: number,
  /**
   * `true` - данные берутся из фильтрованного списка станций;
   * `false` - данные берутся из списка станции словаря.
   */
  withFilter?: boolean,
}
/**
 * Таблица источников. Использует redux `redux-store` (без виртуализации).  
 * По умолчанию берет из фильтрованных данных
 */
export function DatasourcesTable({ withFilter = false, ...props }: DatasourcesTableProps) {
  if (withFilter) return <WithFilterDatasourcesTable {...props} />;
  return <WithoutFilterDatasourcesTable {...props} />;
}
export const MemoDatasourcesTable = React.memo(DatasourcesTable);
MemoDatasourcesTable.displayName = 'MemoDatasourcesTable';
export default DatasourcesTable;

/** Таблица источников с данными из фильтрованного списка станций `redux-store` */
function WithFilterDatasourcesTable(props: Omit<DatasourcesTableProps, 'withoutFilter' >) {
  const { stationId } = props;
  const datasourceIds = useSelector(stationDatasourceIdsFromFilteredSelector(stationId));
  return <LayoutDatasourceTable {...props} datasourceIds={datasourceIds} />;
}
/** Таблица источников с данными из списка станций их словаря `redux-store` */
function WithoutFilterDatasourcesTable(props: Omit<DatasourcesTableProps, 'withoutFilter' >) {
  const { stationId } = props;
  const datasourceIds = useSelector(stationDatasourceIdsSelector(stationId));
  return <LayoutDatasourceTable {...props} datasourceIds={datasourceIds} />;
}

type LayoutProps = PaneProps & {
  stationId: number,
  datasourceIds: number[] | undefined,
}
/** верстка для таблиц источников */
export function LayoutDatasourceTable({ stationId, datasourceIds, ...props }:LayoutProps) {
  const classes = useGeneralStationsStyles();
  if (!datasourceIds || datasourceIds.length === 0) return null;
  return (
    <Pane height="100%" {...props}>
      {
        datasourceIds.map((datasourceId) => {
          return (
            <DatasourceNavigationRow
              className={classes.tableRow}
              key={`${stationId}-${datasourceId}`}
              stationId={stationId}
              datasourceId={datasourceId}
            />
          );
        })
      }
    </Pane>
  );
}
